import { Link } from "react-router-dom";
import Navbar from "../navigation/Navbar";
import Footer from "../../components/app/Footer";
import { Typography } from "@mui/material";
import toList from "../utils/ComponentUtil";
import CustomBreadcrumbs from "../utils/CustomBreadcrumbs";
import Header from "../utils/Header";
import './EarningSummary.scss';

function EarningSummary() {
    const earnings = {
        total: '₹ 9,400.00',
        paid: '₹ 15,500.00',
        unpaid: '₹ 2,900.00',
        split: [
            {
                name: 'Copy Paste Jobs',
                amount: 'Rs. 200.00'
            },
            {
                name: 'Talents',
                amount: 'Rs. 9000.00'
            },
            {
                name: 'Proof Reading',
                amount: 'Rs. 100.00'
            },
            {
                name: 'Review Writing',
                amount: 'Rs. 100.00'
            }
        ]
    }
    const breadcrumbs = [
        toList([{ to: "/", child: "Home" }], Link),
        <Typography className="job-page-name">Earnings Summary</Typography>,
    ];

    return (
        <>
            <Navbar></Navbar>
            <div className="wrapper">
                <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                <Header title="Earnings Summary"></Header>
                <div className="earning-summary">
                    <div className="earnings">
                        <div className="title">Earnings Summary</div>
                        <div className="line"/>
                        <div className="all-earnings">
                            {toList(earnings?.split, undefined, (item, i) =>
                                <div className="earning" key={i}>
                                    <div className="name">{item?.name}</div>
                                    <div className="amount">{item?.amount}</div>
                                </div>
                            )}
                        </div>
                        <div className="line"/>
                        <div className="total">
                            <div className="title">Total Earnings</div>
                            <div className="sum">{earnings?.total}</div>
                        </div>
                    </div>
                    <div className="paid-unpaid">
                        <div className="earning">
                            <div className="label">PAID EARNINGS</div>
                            <div className="sum">{earnings?.paid}</div>
                        </div>
                        <div className="line"/>
                        <div className="earning">
                            <div className="label">UNPAID EARNINGS</div>
                            <div className="sum">{earnings?.unpaid}</div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}

export default EarningSummary;
